import { render } from "./ProduitPartenariat.vue?vue&type=template&id=02c99b9b&ts=true"
import script from "./ProduitPartenariat.vue?vue&type=script&lang=ts"
export * from "./ProduitPartenariat.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__